import { ImageType } from '@mom/shared/utils';

import { ProjectSurveyContent } from './project-survey-content.model';

export class ProfileSurvey {
  id: string;
  title: string;
  image: ImageType;
  lengthOfInterview: number;
  pointsAvailable?: number;
  raffleTicketsAvailable?: number;
  projectSurveyContent: ProjectSurveyContent;
}
